module.exports = __webpack_public_path__ + "static/media/menu-heart.228a0bc5.svg";